import React from 'react';

import styles from './ProdutosHome.module.css';
import fotoTorta from '../../Assets/tortacapa.png';
import fotoBolos from '../../Assets/capaBolos1.jpg';
import fotoRocombole from '../../Assets/capaRocombole.jpg';
import fotoPaes from '../../Assets/capaPaesItalianos.jpg';
import fotoOutros from '../../Assets/capaOutros.jpg';
import { Link } from 'react-router-dom';
import Head from '../Head';
import BtnWhatsapp from '../BtnWhatsapp';

export const ProdutosHome = () => {
  return (
    <>
    <BtnWhatsapp />
      <div className={`${styles.produtos} animeLeft`}>
        <Head
          title="Cantinho d' Bolos | Produtos"
          description="Esses São nossos produtos."
        />
        <div>
          <Link to="tortas">
            <h1 className={`${styles.title}`}>Tortas</h1>
            <img src={fotoTorta} alt="" />
          </Link>
        </div>
        <div>
          <Link to="bolos">
            <h1 className={styles.title}>Bolos</h1>
            <img src={fotoBolos} alt="" />
          </Link>
        </div>
        <div>
          <Link to="/rocomboles">
            <h1 className={styles.title}>Rocomboles</h1>
            <img src={fotoRocombole} alt="" />
          </Link>
        </div>
        <div>
          <Link to="paesitaliano">
            <h1 className={styles.title}>Pães </h1>
            <img src={fotoPaes} alt="" />
          </Link>
        </div>
        <div>
          <Link to="outros">
            <h1 className={styles.title}>Outros</h1>
            <img src={fotoOutros} alt="" />
          </Link>
        </div>
      </div>
    </>
  );
};

export default ProdutosHome;
